import { Skeleton } from "@timeghost/ui/shadcn/skeleton";
import type { JSX } from "react";
import {
	SettingsFocusedNavLoader,
	SettingsFocusedSectionLoader,
} from "@/components/settings/focused/settings-focused.loader";

/** Skeleton for project Details tab (focused edit sections). */
export default function ProjectDetailsLoader(): JSX.Element {
	return (
		<div aria-busy aria-label="Loading" className="grid gap-6 py-2 lg:grid-cols-[max-content_minmax(0,1fr)]">
			<SettingsFocusedNavLoader count={4} />
			<div className="flex min-w-0 flex-col gap-5">
				<SettingsFocusedSectionLoader lines={5} />
				<SettingsFocusedSectionLoader lines={4} />
				<section className="rounded-xl border border-border bg-muted">
					<header className="flex items-start gap-3 border-border border-b p-5">
						<Skeleton className="size-9 shrink-0 rounded-lg" />
						<div className="min-w-0 flex-1 space-y-2">
							<Skeleton className="h-4 w-28" />
							<Skeleton className="h-3 w-44 max-w-full" />
						</div>
					</header>
					<div className="space-y-2 p-5">
						{Array.from({ length: 3 }, (_, index) => (
							<div
								className="flex items-center gap-2 rounded-lg border border-border px-3 py-2"
								key={`person-${index}`}>
								<Skeleton className="h-4 w-40 flex-1" />
								<Skeleton className="h-8 w-28 rounded-md" />
								<Skeleton className="size-8 rounded-md" />
							</div>
						))}
					</div>
				</section>
				<SettingsFocusedSectionLoader lines={3} />
			</div>
		</div>
	);
}
